module.exports = __webpack_public_path__ + "static/media/img2.fda6f6a5.jpg";